import PropTypes from 'prop-types';
import SmartImage from '../smartImage/smartImage';
import styles from './socialIcons.module.scss';
import { baseUrls, followPaths, sharePaths } from './constants';

export default function SocialIcons({
  title = 'Follow Us',
  type = 'follow',
  articleUrl = '',
  items = null,
}) {
  if (Array.isArray(items) && items.length > 0) {
    return (
      <div className={styles.socialIcons}>
        {title && <span className={styles.title}>{title}</span>}
        {items.map((item) => {
          if (!item?.link || !item?.icon?.path) return null;
          return (
            <a
              key={item.link}
              href={item.link}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={item.ariaLabel || item.icon.alt || ''}
            >
              <SmartImage
                className={styles.icon}
                src={item.icon.path}
                alt={item.icon.alt || ''}
                width={item.icon.width}
                height={item.icon.height}
              />
            </a>
          );
        })}
      </div>
    );
  }

  return (
    <div className={styles.socialIcons}>
      {title && <span className={styles.title}>{title}</span>}
      {Object.entries(baseUrls)?.map(([key, value]) => {
        let link;
        switch (type) {
          case 'follow':
            link = followPaths[key] ? value + followPaths[key] : null;
            break;
          case 'share':
            link = sharePaths[key]
              ? value + sharePaths[key] + articleUrl
              : null;
            break;
          default:
            link = null;
        }

        return link ? (
          <a
            key={key}
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={key}
          >
            <i className={`${styles.icon} ${styles[key]}`} />
          </a>
        ) : null;
      })}
    </div>
  );
}

SocialIcons.propTypes = {
  title: PropTypes.string,
  type: PropTypes.string,
  articleUrl: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.shape({
        path: PropTypes.string,
        alt: PropTypes.string,
        width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      }),
      link: PropTypes.string,
      ariaLabel: PropTypes.string,
    })
  ),
};
